import { formatRating } from "@consistency-circle/shared";
import { SmileIcon, TrendingUpIcon } from "lucide-react";

import type { pickWeeklyInsight } from "../../../lib/insights";

export function HeadlineCard({
  rangeLabel,
  consistency,
  avgMood,
  delta,
  insight,
}: {
  readonly rangeLabel: string;
  readonly consistency: number | null;
  readonly avgMood: number | null;
  readonly delta: number | null;
  readonly insight: ReturnType<typeof pickWeeklyInsight>;
}) {
  return (
    <section className="space-y-4 rounded-2xl border border-border bg-card p-5">
      <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
        This {rangeLabel.toLowerCase()}
      </p>

      <div className="grid grid-cols-3 gap-4">
        <div>
          <p className="flex items-center gap-1.5 text-xs font-medium text-muted-foreground">
            <TrendingUpIcon className="h-3.5 w-3.5" />
            Consistent
          </p>
          <p className="mt-1 text-2xl font-semibold tabular-nums">
            {consistency === null ? "-" : `${consistency}%`}
          </p>
        </div>
        <div>
          <p className="flex items-center gap-1.5 text-xs font-medium text-muted-foreground">
            <SmileIcon className="h-3.5 w-3.5" />
            Avg feeling
          </p>
          <p className="mt-1 text-2xl font-semibold tabular-nums">{formatRating(avgMood)}</p>
        </div>
        <div>
          <p className="text-xs font-medium text-muted-foreground">Vs prior {rangeLabel.toLowerCase()}</p>
          <p className="mt-1 text-2xl font-semibold tabular-nums">
            {delta === null ? "-" : delta > 0 ? `▲ ${delta}` : delta < 0 ? `▼ ${Math.abs(delta)}` : "even"}
          </p>
        </div>
      </div>

      {insight && (
        <div className="border-t border-border pt-3.5">
          <p className="text-sm font-medium leading-relaxed">{insight.text}</p>
          <p className="mt-1.5 text-xs text-muted-foreground">
            A correlation in your own logs, not a verdict · based on {insight.sampleSize} logged
            days.
          </p>
        </div>
      )}
    </section>
  );
}
